import { render, staticRenderFns } from "./MSA_Admin.vue?vue&type=template&id=870cf952&scoped=true"
import script from "./MSA_Admin.vue?vue&type=script&lang=js"
export * from "./MSA_Admin.vue?vue&type=script&lang=js"
import style0 from "./MSA_Admin.vue?vue&type=style&index=0&id=870cf952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870cf952",
  null
  
)

export default component.exports